import React from 'react';
import css from './OrderPanel.module.css';
import { SecondaryButton } from '../Button/Button';
const AddToCartButton = ({
  isOwnListing,
  shouldHideHeaderSection,
  onClick,
  children,
  className = css.makeOfferButton,
  ...buttonProps // For additional props like type, disabled, etc.
}) => {
  if (isOwnListing || shouldHideHeaderSection) {
    return null;
  }

  return (
    <SecondaryButton className={className} type="button" onClick={onClick} {...buttonProps}>
      {children}
    </SecondaryButton>
  );
};

export default AddToCartButton;
